import { Loader2 } from "lucide-react";
import { cn } from "@shared/utils";

interface SpinnerProps {
  size?: number;
  className?: string;
}

/** Animated loading spinner atom. */
export function Spinner({ size = 24, className }: SpinnerProps) {
  return (
    <Loader2
      size={size}
      className={cn("animate-spin text-primary", className)}
      aria-label="Cargando"
    />
  );
}
